import { useMutation } from '@tanstack/react-query';

import { getApiClient } from '@cast/api-client';

import { getReportingMonetizationBaseUrl } from './reportingMonetizationBaseUrl';
import {
  notifyReportingMonetizationApiError,
  redirectToExternalUrl,
} from './reportingMonetizationRedirect';

export const useReportingBillingPortalMutation = () => {
  return useMutation({
    mutationFn: () =>
      getApiClient().costReport.getReportingMonetizationBillingPortal({
        body: { baseUrl: getReportingMonetizationBaseUrl() },
      }),
    onSuccess: (response) => {
      redirectToExternalUrl(
        response,
        'Billing portal URL missing or invalid. Expected an absolute http(s) Stripe URL from the API.'
      );
    },
    onError: (error) => {
      notifyReportingMonetizationApiError(error, 'billing portal');
    },
  });
};
